import type { SmartBrandsPropsType } from './grid-banner-app'
import BrandCarousel from '../BrandCarousel/BrandCarousel'
import GenericGridBanner from './GenericGridBrand'

type Props = {
  SmartBrandsProps: SmartBrandsPropsType
}

const SmartBrands = ({ SmartBrandsProps }: Props) => {
  const { brandGridProperties = {}, brandCarouselProperties = {} } =
    SmartBrandsProps?.selectedComponentType || {}

  const { desktop: gridDataDesktop, mobile: gridDataMobile = gridDataDesktop } =
    brandGridProperties

  const {
    desktop: desktopCarousel = {},
    mobile: mobileCarousel = {},
    marginTop: marginTopCarousel = {},
    marginBottom: marginBottomCarousel = {},
  } = brandCarouselProperties

  const isItCarousel =
    Object.keys(desktopCarousel).length > 0 ||
    Object.keys(mobileCarousel).length > 0

  return (
    <>
      {isItCarousel ? (
        <BrandCarousel
          desktop={desktopCarousel}
          mobile={mobileCarousel}
          marginTop={marginTopCarousel}
          marginBottom={marginBottomCarousel}
        />
      ) : (
        <div
          className="allBrands__component-container"
          style={{
            marginTop: `${brandGridProperties?.marginTop}`,
            marginBottom: `${brandGridProperties?.marginBottom}`,
          }}
        >
          <GenericGridBanner
            desktop={gridDataDesktop}
            mobile={gridDataMobile}
          />
        </div>
      )}
    </>
  )
}

export default SmartBrands
